import "./RssFeeds.scss";

import { useState, useEffect } from 'react';
import { api } from '../../utils/api';
import RssFeedModal from "./modals/RssFeedModal";
import { Link } from 'react-router-dom';

export default function RssFeeds() {
  const [rssFeeds, setRssFeeds]           = useState([]);
  const [hasMore, setHasMore]             = useState(true);
  const [page, setPage]                   = useState(1);
  const [rssFeedToEdit, setRssFeedToEdit] = useState(null);
  const perPage                           = 10;

  useEffect(() => {
    const fetchRssFeeds = async () => {
      const { data } = await api.get(`/rss_feeds?page=${page}&per_page=${perPage}`);

      if (page === 1) {
        setRssFeeds(data);
      } else {
        setRssFeeds(prev => [...prev, ...data]);
      }

      // If fewer than perPage jobs came back, no more pages
      if (data.length < perPage) {
        setHasMore(false);
      }
    };

    fetchRssFeeds();
  }, [page]);

  const processFeed = async (id) => {
    const { data: updatedFeed } = await api.post(`/rss_feeds/${id}/process`);

    setRssFeeds(prevFeeds =>
      prevFeeds.map(feed => (feed.id === updatedFeed.id ? updatedFeed : feed))
    );
  };

  return (
    <div className="__rss-feeds">
      <div className="__rss-feeds__container">
        <div className="__rss-feeds__header">
          RSS Feeds
        </div>

        <div className='__rss-feeds__buttons'>
          <button className='add-new ppy-btn ppy-btn-primary' onClick={() => setRssFeedToEdit(undefined)}>
            Add New RSS Feed
          </button>
        </div>

        <table className="__rss-feeds__results">
          <thead>
            <tr>
              <th>ID</th>
              <th>Title</th>
              <th>Location</th>
              <th>Unprocessed Count</th>
              <th>Last Processed</th>
              <th></th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {rssFeeds.map((rssFeed) => (
              <tr key={rssFeed.id} className="rss_feed">
                <td><Link to={`/rss-feed/${rssFeed.id}`}>{rssFeed.id}</Link></td>
                <td>{rssFeed.title}</td>
                <td>{rssFeed.location}</td>
                <td>{rssFeed.unlabeled_postings}</td>
                <td>{rssFeed.last_processed_at ? new Date(rssFeed.last_processed_at).toLocaleString() : ""}</td>
                <td>
                  <div className="centered">
                    <button className='add-new ppy-btn ppy-btn-primary' onClick={() => setRssFeedToEdit(rssFeed)}>
                      Edit
                    </button>
                  </div>
                </td>
                <td>
                  <div className="centered">
                    <button className='add-new ppy-btn ppy-btn-primary' onClick={() => processFeed(rssFeed.id)}>
                      Process
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {hasMore && rssFeeds.length > 0 && (
          <div className="__user-data__load-more">
            <button
              className="ppy-btn ppy-btn-primary"
              onClick={() => setPage(prev => prev + 1)}
            >
              Load More
            </button>
          </div>
        )}
      </div>

      <RssFeedModal
        show={rssFeedToEdit !== null}
        handleClose={() => setRssFeedToEdit(null)}
        rssFeed={rssFeedToEdit}
        rssFeeds={rssFeeds}
        setRssFeeds={setRssFeeds}
      />
    </div>
  );
}